'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../themes/alert.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');

const baseListItemStyle = styled.css`
  display: block;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  margin: 0;
  overflow-wrap: anywhere;
`;

exports.baseListItemStyle = baseListItemStyle;
//# sourceMappingURL=listitem.js.map
